module.exports = __webpack_public_path__ + "static/media/cloud2.116300ab.png";